export function fitAllAction() {
  const { t } = useI18n();

  return {
    title: t('components.xeokit_viewer.context_menu.view_fit_all') || 'View Fit All',
    doAction: function (context) {
      const scene = context.viewer.scene;
      context.viewer.cameraFlight.flyTo({
        projection: 'perspective',
        aabb: scene.getAABB(),
        duration: 0.5,
      });
    },
  };
}
